var map = {
	"./ArrowRight": 6629,
	"./ArrowRight.vue": 6629,
	"./CheckCircle": 4975,
	"./CheckCircle.vue": 4975,
	"./CheckCircleFill": 3961,
	"./CheckCircleFill.vue": 3961,
	"./HandleIcon": 8579,
	"./HandleIcon.vue": 8579,
	"./TrashIcon": 6278,
	"./TrashIcon.vue": 6278,
	"./benefit1.png": 8105,
	"./benefit2.png": 9254,
	"./benefit3.png": 7256,
	"./check-mark-green.svg": 8297,
	"./check-mark.svg": 1673,
	"./checkbox.png": 1799,
	"./chevron-down-dark-icon.svg": 8280,
	"./chevron-down-icon.svg": 1524,
	"./chevron-right-icon.svg": 3297,
	"./divider-icon.svg": 9388,
	"./dots-icon.svg": 1494,
	"./drag-icon.svg": 3662,
	"./file-icon.svg": 8954,
	"./fire-icon.svg": 4197,
	"./form-icon.svg": 664,
	"./heading-1-icon.svg": 7111,
	"./heading-2-icon.svg": 9356,
	"./heading-3-icon.svg": 8673,
	"./icon-info.svg": 1583,
	"./image-icon.svg": 3749,
	"./incomplete-icon.svg": 5932,
	"./info-icon-2.svg": 9016,
	"./plus-border-icon.svg": 7699,
	"./plus-icon.svg": 5176,
	"./scheduling-icon.svg": 6980,
	"./search-2.svg": 5426,
	"./search.svg": 9262,
	"./share-arrow.svg": 3712,
	"./simple-task-icon.svg": 2847,
	"./sort-icon.svg": 9025,
	"./task-icon.svg": 8807,
	"./task-list-icon.svg": 384,
	"./text-icon.svg": 8770,
	"./text-type-icon.svg": 6078,
	"./trash-icon.svg": 1967,
	"./tv-icon.svg": 6424,
	"./user-icon.svg": 2096,
	"./youtube-icon.svg": 2895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;